import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import {
  AutomotiveAftermarketProfileListState,
  AutomotiveAftermarketProfileListStateModel,
} from './automotive-aftermarket-profile-list.state';
import {
  AutomotiveAftermarketProfileListInitialState,
  AutomotiveAftermarketProfileListLoad,
} from './automotive-aftermarket-profile-list.actions';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { ListSearchCriteriaFacade } from '../../../list-search-criteria/list-search-criteria.facade';
import { PlannerProfile, PlannerProfileListSearchCriteria } from '../../../../models';
import { ListSearchCriteriaType } from '../../../list-search-criteria';

@Injectable({ providedIn: 'root' })
export class AutomotiveAftermarketProfileListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<AutomotiveAftermarketProfileListStateModel> = this.store.select(
    AutomotiveAftermarketProfileListState.getState,
  );
  items$: Observable<PlannerProfile[]> = this.store.select(AutomotiveAftermarketProfileListState.getItems);
  loaded$: Observable<boolean> = this.store.select(AutomotiveAftermarketProfileListState.getLoaded);

  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  loadAll(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.AutomotiveAftermarketProfiles)
      .subscribe((searchCriteria: PlannerProfileListSearchCriteria) => {
        this.store.dispatch(new AutomotiveAftermarketProfileListLoad(searchCriteria));
      });
  }

  loadListForDialog(searchCriteria: PlannerProfileListSearchCriteria): void {
    this.store.dispatch(new AutomotiveAftermarketProfileListLoad(searchCriteria));
  }

  setInitialState(): void {
    this.store.dispatch(new AutomotiveAftermarketProfileListInitialState());
  }
}
